module.exports = __webpack_public_path__ + "img/start_page_banner.b33bea37.jpeg";